import React from 'react';

import AppHeader from '../../../../Layout/Header';
import FooterComponent from '../../../../Layout/Footer';
import banner from '../../../../Assets/Linkages/SpaceDestinationSchools/Space-Destination-Schools-Banner.jpg';
import '../../../../Styles/Linkages&Outreach.css';
import SpaceDestinationIntroduction from './SpaceDestinationIntroduction';
import SpaceDestinationLegacy from './SpaceDestinationLegacy';
import SpaceDestinationEvents from './SpaceDestinationEvents';

const SpaceDestinationSchools = () => (
  <>
    <AppHeader />
    <main className="space-destination-schools-page">
      <section className="outreach-event-hero" aria-label="Space Destination Schools">
        <img
          className="outreach-event-banner"
          src={banner}
          alt="Space Destination Schools"
        />
      </section>
      <SpaceDestinationIntroduction />
      <SpaceDestinationLegacy />
      <SpaceDestinationEvents />
    </main>
    <FooterComponent />
  </>
);

export default SpaceDestinationSchools;
